'use client'
import KeenSlider from 'keen-slider'
import React, { useEffect } from 'react'

const Testimonials = () => {
    useEffect(() => {
        const keenSlider = new KeenSlider(
            '#keen-slider',
            {
                loop: true,
                slides: {
                    origin: 'center',
                    perView: 1.25,
                    spacing: 16,
                },
                breakpoints: {
                    '(min-width: 1024px)': {
                        slides: {
                            origin: 'auto',
                            perView: 1.5,
                            spacing: 32,
                        },
                    },
                },
            }
        );

        const keenSliderPrevious = document.getElementById('keen-slider-previous');
        const keenSliderNext = document.getElementById('keen-slider-next');

        const keenSliderPreviousDesktop = document.getElementById('keen-slider-previous-desktop');
        const keenSliderNextDesktop = document.getElementById('keen-slider-next-desktop');

        keenSliderPrevious?.addEventListener('click', () => keenSlider.prev());
        keenSliderNext?.addEventListener('click', () => keenSlider.next());

        keenSliderPreviousDesktop?.addEventListener('click', () => keenSlider.prev());
        keenSliderNextDesktop?.addEventListener('click', () => keenSlider.next());

        // Cleanup function to destroy KeenSlider when the component unmounts
        return () => {
            keenSlider.destroy();
        };
    }, []);
    const reviews = [
        {
            name: "Sundaresh,Edison,NJ",
            review: "Chaivio's chai can transport you to a world of flavor & relaxation. It has become a beloved beverage for me including our entire office staff every day to appreciate for its cultural significance & the unique blend of spices that make each cup a delightful authentic experience."

        },
        {
            name: "Chetan Sapkal",
            review: "On returning from India I tried searching for the authentic taste that I became addicted to. For a quick flavor, I went to Chaivio. The taste took me back, it is amazing and brings back very fond memories.",
        },

        {
            name: "Arnav Jain",
            review: "Chaivio's Masala Chai is the most satisfying chai I've had outside of India...",
        },

        {
            name: "Nicole Brook",
            review: "Excellent coffee, tea and great vibes to locals, expats and visitors alike...",
        },

        {
            name: "Edan Berger",
            review: "A local fan favourite Tea & Coffee bar that offers a welcome respite from the city's crowded center and greatest tea, of course.",
        },
    ]
    return (

        <section className="bg-[#ffd7cd] backdrop-blur-sm rounded-lg overflow-x-hidden w-[96%] max-w-[1440px]">
            <div className="mx-auto max-w-[1440px] px-4 py-12 sm:px-6 lg:me-0 lg:py-16 lg:pe-0 lg:ps-8 xl:py-24">
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:items-center lg:gap-16">
                    <div className="max-w-xl text-left">
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                            Don&apos;t just take our word for it...
                        </h2>

                        <p className="mt-4 text-gray-700">
                            Here&apos;s what our customers have to say about us.
                        </p>

                        <div className="hidden lg:mt-8 lg:flex lg:gap-4">
                            <button
                                aria-label="Previous slide"
                                id="keen-slider-previous-desktop"
                                className="rounded-full border border-amber-600 p-3 text-amber-600 transition hover:bg-amber-600 hover:text-white"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="h-5 w-5 rtl:rotate-180"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15.75 19.5L8.25 12l7.5-7.5"
                                    />
                                </svg>
                            </button>

                            <button
                                aria-label="Next slide"
                                id="keen-slider-next-desktop"
                                className="rounded-full border border-amber-600 p-3 text-amber-600 transition hover:bg-amber-600 hover:text-white"
                            >
                                <svg
                                    className="h-5 w-5 rtl:rotate-180"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9 5l7 7-7 7"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div className="-mx-6 lg:col-span-2 lg:mx-0">
                        <div id="keen-slider" className="keen-slider">
                            {
                                reviews.map((review, index) => {
                                    return (
                                        <div key={index} className="keen-slider__slide cursor-grab active:cursor-grabbing">
                                            <blockquote
                                                className="flex h-full flex-col justify-between bg-white p-6 shadow-sm sm:p-8 lg:p-12"
                                            >
                                                <div>
                                                    <div className="mt-4">
                                                        <p className="mt-4 leading-relaxed text-gray-700">
                                                            {review.review}
                                                        </p>
                                                    </div>
                                                </div>

                                                <footer className="mt-4 text-sm font-medium text-gray-700 sm:mt-6">
                                                    &mdash; {review.name}
                                                </footer>
                                            </blockquote>
                                        </div>)
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonials